import { forwardRef } from "react";
import SvgIcon from "@mui/material/SvgIcon";
import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgManualTest = forwardRef((props, ref) => {
	return React.createElement(SvgIcon, {
		...props,
		ref
	}, /* @__PURE__ */ _jsx("path", {
		d: "M0.75 6.751V2.25C0.75 1.85218 0.908035 1.47064 1.18934 1.18934C1.47064 0.908035 1.85218 0.75 2.25 0.75H6.75",
		fill: "none",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M23.25 6.751V2.25C23.25 1.85218 23.092 1.47064 22.8107 1.18934C22.5294 0.908035 22.1478 0.75 21.75 0.75H17.25",
		fill: "none",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M0.75 17.25V21.75C0.75 22.1478 0.908035 22.5294 1.18934 22.8107C1.47064 23.092 1.85218 23.25 2.25 23.25H6.75",
		fill: "none",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M23.25 17.25V21.75C23.25 22.1478 23.092 22.5294 22.8107 22.8107C22.5294 23.092 22.1478 23.25 21.75 23.25H17.25",
		fill: "none",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M7.875 8.625C7.875 9.71902 8.3096 10.7682 9.08318 11.5418C9.85677 12.3154 10.906 12.75 12 12.75C13.094 12.75 14.1432 12.3154 14.9168 11.5418C15.6904 10.7682 16.125 9.71902 16.125 8.625C16.125 7.53098 15.6904 6.48177 14.9168 5.70818C14.1432 4.9346 13.094 4.5 12 4.5C10.906 4.5 9.85677 4.9346 9.08318 5.70818C8.3096 6.48177 7.875 7.53098 7.875 8.625Z",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M18.337 18.75C17.8781 17.4353 17.0215 16.2958 15.8861 15.4895C14.7507 14.6833 13.3926 14.2501 12 14.2501C10.6075 14.2501 9.24936 14.6833 8.11394 15.4895C6.97851 16.2958 6.12198 17.4353 5.66302 18.75",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}));
});
export default SvgManualTest;
